import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import React from 'react';
import DatePicker, {DatePickerProps} from './DatePicker';
import {Dayjs} from 'dayjs';
import {isoDateFormat} from 'common/formats';
import {useController, useFormContext} from 'react-hook-form';
import {SetValueOptions} from 'components/hook-form/helpers';
import {useRegisterLabel} from 'common/context/FormContext';

type FormikDatePickerProps = Omit<DatePickerProps, 'value' | 'onChange'> & {
   value?: any;
   name: string;
   onChange?: (date: Date | null) => void;
};

type _DatePickerProps = FormikDatePickerProps & {
   touched: boolean;
   setFieldValue: (name: string, value?: Date | string | null, options?: any) => void;
};

const _DatePicker = ({
   name,
   touched,
   error,
   value,
   onChange,
   // onBlur,
   setFieldValue,
   substrDate,
   disabled,
   ...restProps
}: _DatePickerProps) => {
   const hasError = Boolean(touched && error);
   const hasClearIcon = Boolean(value && !disabled);
   const handleChange = (date: Dayjs | null) => {
      if (onChange && date) {
         onChange(date.toDate());
         // return;
      }
      try {
         setFieldValue(
            name,
            substrDate ? date?.format(isoDateFormat) : date?.toISOString(),
            SetValueOptions
         );
      } catch (e) {}
   };
   return (
      <DatePicker
         helperText={hasError ?? error}
         error={hasError}
         name={name}
         value={value}
         disableMaskedInput
         // onBlur={onBlur}
         disabled={disabled}
         {...restProps}
         InputProps={{
            // inputProps: {role: 'textbox'},
            endAdornment: hasClearIcon && (
               <InputAdornment position="end">
                  <IconButton
                     size="small"
                     onClick={(e) => {
                        e.stopPropagation();
                        setFieldValue(name, null, SetValueOptions);
                     }}
                  >
                     <ClearIcon fontSize="small" />
                  </IconButton>
               </InputAdornment>
            ),
         }}
         onChange={handleChange}
      />
   );
};

const HookFormDatePicker = ({name, onChange, ...restProps}: FormikDatePickerProps) => {
   const methods = useController({
      name,
   });

   useRegisterLabel(name, restProps.label as string);
   const {
      field: {value},
      fieldState: {error: _error, isTouched},
   } = methods;
   const {setValue} = useFormContext();

   return (
      <_DatePicker
         name={name}
         value={value || ''}
         onChange={onChange}
         setFieldValue={setValue}
         error={!!_error?.message}
         helperText={_error?.message}
         touched={isTouched}
         {...restProps}
      />
   );
};

export default React.memo(HookFormDatePicker);
